var BigInt: any;
namespace Nobox.Billing {

    @Serenity.Decorators.registerFormatter()
    export class CategoryFormatter implements Slick.Formatter {
        format(ctx: Slick.FormatterContext) {
            let idList = ctx.value;
            if (!idList)
                return "";

            idList = idList.split(",") as number[]
            let byId = MembershipAddonsCategoryRow.getLookup().itemById;
            var elList = "";
            var idLast = 0;
            idList.forEach(function (x) {
                let g = byId[BigInt(x)] as any;
                idLast = x;
                if (!g) {
                    elList += `<span id="${x.toString()}" class="list-link">${x.toString()}, </span>`;
                } else {
                    elList += `<span id="${x.toString()}" class="list-link">${Q.htmlEncode(g.Name)}, </span>`;
                }
            });
            if (byId[BigInt(idLast)]) {
                return `<a href="javascript:;">${elList.replace(byId[BigInt(idLast)].Name + ", ", byId[BigInt(idLast)].Name)}</a>`;
            } else {
                return `<a href="javascript:;">${idLast.toString() + ", ", idLast.toString()} </a>`;
            }
        }
    }
}